import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/global/Button';
import EditIcon from '../../../../../../../../components/icons/EditIcon';
import { capitalize } from '../../../../../../../../util/text';

const propTypes = {
  values: PropTypes.shape({
    relationship: PropTypes.string,
  }),
  onUpdate: PropTypes.func,
};

const FundraiserEventReviewDetails = ({ values, onUpdate }) => {
  return (
    <>
      <tr>
        <td className="text-left">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mr-1">
              <h3 className="mb-0">Charity name</h3>
              <p className="text-base">{capitalize(values.charity_name)}</p>
            </div>
            <Button
              btnStyle="link"
              btnSize="sm"
              onClick={onUpdate}
              className="ml-auto review-step-edit-icon"
            >
              <EditIcon color="#0d84fe" size="22px" className="ml-1" />
            </Button>
          </div>
        </td>
      </tr>
    </>
  );
};

FundraiserEventReviewDetails.propTypes = propTypes;

export default FundraiserEventReviewDetails;
